import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export interface LoggedInUser {
  user: {
    email: string;
    name: string;
    id: string;
    diff: number;
  }
  features?: string[];
  token: string;
}

//  fetch(
export const fetchWithAuth = async (input: any, init: any = {}) => {
  let token = null;
  try {
    const user = localStorage.getItem("user");
    if (user) {
      // token = JSON.parse(user).token;
    }
  } catch (error) {
      console.error("Error parsing user from localStorage", error);
  }

  const headers = new Headers(init.headers || {});
  if (token) {
      headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(input, {
      ...init,
      headers,
  });
};
